import styled from 'styled-components';
import { Select } from '@bigcommerce/big-design';

const STATES = {
	options: [
		{ value: '', content: '--Please Select A State--' },
		{ value: 'Alabama', content: 'Alabama' },
		{ value: 'Alaska', content: 'Alaska' },
		{ value: 'Arizona', content: 'Arizona' },
		{ value: 'Arkansas', content: 'Arkansas' },
		{ value: 'California', content: 'California' },
		{ value: 'Colorado', content: 'Colorado' },
		{ value: 'Connecticut', content: 'Connecticut' },
		{ value: 'Delaware', content: 'Delaware' },
		{ value: 'Florida', content: 'Florida' },
		{ value: 'Georgia', content: 'Georgia' },
		{ value: 'Hawaii', content: 'Hawaii' },
		{ value: 'Idaho', content: 'Idaho' },
		{ value: 'Illinois', content: 'Illinois' },
		{ value: 'Indiana', content: 'Indiana' },
		{ value: 'Iowa', content: 'Iowa' },
		{ value: 'Kansas', content: 'Kansas' },
		{ value: 'Kentucky', content: 'Kentucky' },
		{ value: 'Louisiana', content: 'Louisiana' },
		{ value: 'Maine', content: 'Maine' },
		{ value: 'Maryland', content: 'Maryland' },
		{ value: 'Massachusetts', content: 'Massachusetts' },
		{ value: 'Michigan', content: 'Michigan' },
		{ value: 'Minnesota', content: 'Minnesota' },
		{ value: 'Mississippi', content: 'Mississippi' },
		{ value: 'Missouri', content: 'Missouri' },
		{ value: 'Montana', content: 'Montana' },
		{ value: 'Nebraska', content: 'Nebraska' },
		{ value: 'Nevada', content: 'Nevada' },
		{ value: 'New Hampshire', content: 'New Hampshire' },
		{ value: 'New Jersey', content: 'New Jersey' },
		{ value: 'New Mexico', content: 'New Mexico' },
		{ value: 'New York', content: 'New York' },
		{ value: 'North Carolina', content: 'North Carolina' },
		{ value: 'North Dakota', content: 'North Dakota' },
		{ value: 'Ohio', content: 'Ohio' },
		{ value: 'Oklahoma', content: 'Oklahoma' },
		{ value: 'Oregon', content: 'Oregon' },
		{ value: 'Pennsylvania', content: 'Pennsylvania' },
		{ value: 'Rhode Island', content: 'Rhode Island' },
		{ value: 'South Carolina', content: 'South Carolina' },
		{ value: 'South Dakota', content: 'South Dakota' },
		{ value: 'Tennessee', content: 'Tennessee' },
		{ value: 'Texas', content: 'Texas' },
		{ value: 'Utah', content: 'Utah' },
		{ value: 'Vermont', content: 'Vermont' },
		{ value: 'Virginia', content: 'Virginia' },
		{ value: 'Washington', content: 'Washington' },
		{ value: 'West Virginia', content: 'West Virginia' },
		{ value: 'Wisconsin', content: 'Wisconsin' },
		{ value: 'Wyoming', content: 'Wyoming' },
	],
};

const PROVINCES = {
	options: [
		{ value: '', content: '--Please Select A Province--' },
		{ value: 'Alberta', content: 'Alberta' },
		{ value: 'British Columbia', content: 'British Columbia' },
		{ value: 'Manitoba', content: 'Manitoba' },
		{ value: 'New Brunswick', content: 'New Brunswick' },
		{
			value: 'Newfoundland and Labrador',
			content: 'Newfoundland and Labrador',
		},
		{
			value: 'Northwest Territories',
			content: 'Northwest Territories',
		},
		{ value: 'Nova Scotia', content: 'Nova Scotia' },
		{ value: 'Nunavut', content: 'Nunavut' },
		{ value: 'Ontario', content: 'Ontario' },
		{ value: 'Prince Edward Island', content: 'Prince Edward Island' },
		{ value: 'Quebec', content: 'Quebec' },
		{ value: 'Saskatchewan', content: 'Saskatchewan' },
		{ value: 'Yukon Territory', content: 'Yukon Territory' },
	],
};

export default function StatesDropdown({ getValue, setValue, country }) {
	const options = country === 'United States' ? STATES : PROVINCES;

	return (
		<Select
			filterable={true}
			options={[options]}
			value={getValue('state_or_province')}
			onOptionChange={(value) => setValue('state_or_province', value)}
			placement={'bottom-start'}
			required
		/>
	);
}
